import { FC } from 'react'
import {
  Container,
  CollapsibleTopicItem,
  Col,
  Row,
  Section,
  ShareButtons,
} from 'atoms'
import {
  ContactCard,
} from 'organisms'
import {
  CollapsibleContentCompCoach,
  CollapsibleResourceDesc,
  CollapsibleContentComComp,
  CollapsibleContentSelfConf,
  CollapsibleContentSelfMan,
  CollapsibleContentBalance,
} from './CollapsibleContent'

import ImgCompCoach from 'assets/images/content/identitaet.jpg'
import ImgResourceDesc from 'assets/images/content/selbstbestimmung.jpg'
import ImgComComp from 'assets/images/content/vorbereitung_fuerhungspositionen.jpg'
import ImgSelfConf from 'assets/images/content/kompetenzstaerkung.jpg'
import ImgSelfMan from 'assets/images/content/frauencoach-firmen.jpeg'
import ImgBalance from 'assets/images/content/gesundheit_balance.jpg'

const SeminareWorkshops: FC<unknown> = () => (
  <>
    <Section background="vintage">
      <Container>
        <h1>
          Seminare &amp; Workshops
        </h1>
        <Row>
          <Col xs={12} lg={6}>
            <CollapsibleTopicItem
              groupId="companies"
              key="compCoach"
              id="compCoach"
              labelColor='green'
              label="Kompaktcoaching für Frauen"
              labelAs="h2"
              labelImage={ImgCompCoach}
              content={<CollapsibleContentCompCoach />}
            />
            <CollapsibleTopicItem
              groupId="companies"
              key="resourceDesc"
              id="resourceDesc"
              labelColor='green'
              label="Ressourcenerklärung für Frauen"
              labelAs="h2"
              labelImage={ImgResourceDesc}
              content={<CollapsibleResourceDesc />}
            />
            <CollapsibleTopicItem
              groupId="companies"
              key="comComp"
              id="comComp"
              labelColor='green'
              label="Kommunikations- und Konfliktkompetenzen von A bis Z für Frauen"
              labelAs="h2"
              labelImage={ImgComComp}
              content={<CollapsibleContentComComp />}
            />
          </Col>
          <Col xs={12} lg={6}>
            <CollapsibleTopicItem
              groupId="companies"
              key="selfConf"
              id="selfConf"
              labelColor='green'
              label="Selbstbewusstsein und Persönlichkeit zeigen für Frauen"
              labelAs="h2"
              labelImage={ImgSelfConf}
              content={<CollapsibleContentSelfConf />}
            />
            <CollapsibleTopicItem
              groupId="companies"
              key="selfMan"
              id="selfMan"
              labelColor='green'
              label="Selbstmanagementkompentenzen für Frauen"
              labelAs="h2"
              labelImage={ImgSelfMan}
              content={<CollapsibleContentSelfMan />}
            />
            <CollapsibleTopicItem
              groupId="companies"
              key="balance"
              id="balance"
              labelColor='green'
              label="Balancekompetenzen für Frauen"
              labelAs="h2"
              labelImage={ImgBalance}
              content={<CollapsibleContentBalance />}
            />
          </Col>
        </Row>
      </Container>
    </Section>
    <Section>
      <Container>
        <Row className="justify-content-center">
          <Col xl={6} className="my-4">
            <p className="text-center text-highlight">
              Wählen Sie einfach Ihr Thema aus.<br/>
              Alle Module sind, wenn gewünscht, beliebig kombinierbar.<br/>
              {`Oder Sie entscheiden sich für das KompaktCoaching: da haben Sie alle Module unter einem Dach gebündelt.`}<br/>
              Einfach Kontakt aufnehmen und Einzelheiten besprechen.<br/>
              Und schon kann es losgehen.
            </p>
          </Col>
        </Row>
      </Container>
    </Section>
    <Section background="vintage">
      <Container>
        <ContactCard />
      </Container>
    </Section>
    <Section>
      <Container>
        <ShareButtons className="d-none d-md-block" full />
        <ShareButtons className="d-block d-md-none" full size={40} />
      </Container>
    </Section>
  </>
)

export default SeminareWorkshops
